import { reportDialog, reportCreate } from 'plugins/router/routes/reports.ts'
import { cisCreate, cisUpdate } from 'plugins/router/routes/cis.ts'
import { taskCreate, taskUpdate } from 'plugins/router/routes/task.ts'
import { craftsmanTaskCreate } from 'plugins/router/routes/craftsmanTasks.ts'
import { noteCreate, noteEdit, noteView } from 'plugins/router/routes/notes.ts'
import {
	notificationDocuments,
	notificationView,
} from 'plugins/router/routes/notification.ts'
import { sendgreeting } from 'plugins/router/routes/sendgreeting.ts'
import { dialogFilePreview } from 'plugins/router/routes/global/dialogFilePreview.ts'
import {
	buildingPropertyManager,
	buildingExport,
} from 'plugins/router/routes/buildings-modals.ts'
import {
	documenttypeExport,
	documenttypeCutoff,
	documenttypeBulkEdit,
} from 'plugins/router/routes/documenttype-modals.ts'

//TODO: need to verify meta guards like isAdmin, isTeam, auth, etc. for each modal
const modals = [
	reportDialog,
	reportCreate,
	cisCreate,
	cisUpdate,
	taskCreate,
	taskUpdate,
	craftsmanTaskCreate,
	noteCreate,
	noteEdit,
	noteView,
	notificationDocuments,
	notificationView,
	sendgreeting,
	dialogFilePreview,
	buildingPropertyManager,
	buildingExport,
	documenttypeExport,
	documenttypeCutoff,
	documenttypeBulkEdit,
]
export default modals.map((modal) => {
	modal.meta = {
		...modal.meta,
		modal: true,
	}
	return modal
})
